import { useState, useEffect } from 'react';

/**
 * Кастомный хук, который определяет браузер, используемый клиентом.
 * При необходимости можно будет добавить определение других браузеров
 *
 * @returns {Object} Объект с булевыми значениями, указывающими на тип браузера.
 * @property {boolean} isSafari - Указывает, используется ли браузер Safari.
 * @property {boolean} isChrome - Указывает, используется ли браузер Chrome.
 */
export function useDevice() {
  const [browser, setBrowser] = useState({
    isSafari: false,
    isChrome: false,
  });

  useEffect(() => {
    if (typeof navigator !== 'undefined') {
      const userAgent = navigator.userAgent;

      const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);
      const isChrome = /chrome|crios/i.test(userAgent) && !/edge|edg|opr/i.test(userAgent);

      setBrowser({
        isSafari,
        isChrome,
      });
    }
  }, []);

  return browser;
}
